module.exports = __webpack_public_path__ + "img/Protekt-logo-medium.7911e87f.png";